<template>
  <Form as="div">
    <div>
      <div class="container">
        <status-info v-if="!viewModel.ok" :value="viewModel.error" />
        <change-frequency
          v-if="viewModel.ok && (completedView === null || completedView.message === null)"
          :modelValue="viewModel.success"
        />
        <status-info v-if="completedView" :value="completedView.message" />
      </div>
    </div>
  </Form>
</template>
<script lang="ts">
import ChangeFrequency from './ChangeFrequency.vue';
import StatusInfo from './StatusInfo.vue';
import {
  PaymentFrequencyStoreState,
  PaymentFrequency
} from '@/store/modules/interfaces/paymentFrequencyStoreState';
import { mapState } from 'vuex';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  components: {
    ChangeFrequency,
    StatusInfo
  },
  props: {
    viewModel: {
      type: Object as PropType<PaymentFrequency>
    }
  },
  computed: {
    ...mapState('paymentFrequency', {
      completedView: (state: any) => (state as PaymentFrequencyStoreState).completedView
    })
  }
});
</script>
<style lang="scss" scoped></style>
